import * as types from './constants';

// Generate Analytics Links Report
export const generateAnalyticsLinksReportRequest = data => (
  { type: types.GENERATE_ANALYTICS_LINKS_REPORT_REQUEST, payload: data }
);

export const generateAnalyticsLinksReportDone = data => (
  { type: types.GENERATE_ANALYTICS_LINKS_REPORT_DONE, payload: data }
);

export const generateAnalyticsLinksReportFailed = errors => (
  { type: types.GENERATE_ANALYTICS_LINKS_REPORT_FAILED, payload: errors }
);

export const generateAnalyticsLinksReportReset = () => (
  { type: types.GENERATE_ANALYTICS_LINKS_REPORT_RESET }
);